<template>
  <div>
    <headernav></headernav>
    <router-view></router-view>
    <div class="hig">
      <footerend></footerend>
    </div>
  </div>
</template>

<script>
import headernav from "../components/common/headernav";
import footerend from "../components/common/footerend";
export default {
  name: "index",
  components: {
    headernav,
    footerend
  },
  data() {
    return {};
  },
  methods: {
    watchrouter() {
      document.documentElement.scrollTop = 0;
    }
  },
  watch: {
    $route: {
      handler: function(val, oldVal) {
        this.watchrouter();
      },
      deep: true
    }
  }
};
</script>

<style scoped>
@import "../assets/css/index.css";
</style>



// WEBPACK FOOTER //
// src/pages/index.vue